<template>
  <div v-if="!product.is_redemption && !product.redemption_points_offer_id">
    <span :class="{ deal }">{{ formatCurrency(priceWithModifiers) }}</span>
    <span v-if="byweight" class="caption"
      >{{ "\xa0" }}({{ qty }} {{ byWeightDisplay }})</span
    >
    <span v-if="deal" class="color-fire-engine-red font-weight-semibold ml-1">
      {{ formatCurrency(priceAfterPromos) }}
    </span>
  </div>
  <div v-else>
    <span
      v-if="product.redemption_points_offer_id"
      class="color-fire-engine-red font-weight-semibold"
    >
      Free! ({{ sumPoints }} point<span v-if="sumPoints > 1">s</span>)
    </span>
    <span v-else class="color-fire-engine-red font-weight-semibold">
      Free! (Club Reward)
    </span>
  </div>
</template>
<script>
import { formatCurrency } from "@/util.js";

export default {
  name: "PromotionsPriceDisplay",
  computed: {
    byWeightDisplay() {
      return this.qty > 1 ? "lbs" : "lb";
    },
    sumPoints() {
      return this.product.redemption_points_offer * this.qty;
    },
  },
  data: () => ({
    deal: false,
    priceAfterPromos: null, // null because 0 is valid (discounts greater than price)
    priceWithModifiers: null,
  }),
  methods: {
    formatCurrency,
    async setNewPriceForPromotionProduct() {
      if (!this.items) {
        return;
      }
      const item = this.items[this.product.item_id];
      this.priceAfterPromos = item?.priceAfterPromos;
      this.priceWithModifiers = item?.priceWithModifiers;
    },
    updateDeal() {
      this.deal =
        this.priceAfterPromos !== null &&
        this.priceWithModifiers > this.priceAfterPromos;
    },
  },
  async mounted() {
    // need this in mount for click of Proposition 65 WARNING (v-if destroys)
    await this.setNewPriceForPromotionProduct();
    this.updateDeal();
  },
  props: {
    byweight: Boolean,
    items: Object,
    product: Object,
    qty: Number,
  },
  watch: {
    items: async function () {
      await this.setNewPriceForPromotionProduct();
      this.updateDeal();
    },
  },
};
</script>

<style scoped>
.deal {
  color: var(--color-nobel);
  text-decoration: line-through;
}
</style>
